import { useParams } from "react-router-dom";
import ViewContacts from "@swivu/shared-ui/src/components/ViewContacts.js";

const ViewContactsWrapper = () => {
  const { id, slug } = useParams<{ id: string; slug: string }>();

  return (
    <div className={"px-4"}>
      <ViewContacts.Provider
        id={id!}
        slug={slug!}
        api="public"
        baseUrl={`/p/${slug}/contacts/${id}/contact`}
      >
        <ViewContacts />
      </ViewContacts.Provider>
    </div>
  );
};

export default ViewContactsWrapper;
